const styles = {
  container: {
    color: '#3b3b3b',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
  },
  grayText: {
    color: '#848484',
  },
  timer: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    fontFamily: 'AvenirNext-DemiBold, monospace',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1,
    color: '#ed6c02',
    padding: '6px 12px',
    minWidth: '64px',
    textAlign: 'center',
  },
  timerUrgent: {
    color: '#f00',
    animation: 'pickupTimerBlink 0.6s linear infinite',
    '@keyframes pickupTimerBlink': {
      '0%, 100%': { opacity: 1 },
      '50%': { opacity: 0.5 },
    },
  },
  listWrapper: {
    marginTop: '12px',
    maxHeight: 'calc(100vh - 320px)',
    overflowY: 'auto',
    // FormControlLabel has a default -11px left margin; without left padding the
    // overflow container clips the radio on the left edge.
    paddingLeft: '11px',
  },
  emptyMessage: {
    padding: '24px 8px',
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
};

export default styles;
